export default {
  name: 'alert',
  props: {
    type: String,
    color: String,
    value: Boolean
  }
}
